import React, { useState } from "react";
import MediaModal from "./MediaModal";
import { path } from "../../path";

function formatDate(inputDate) {
  const date = new Date(inputDate);

  const options = {
    day: "2-digit",
    month: "short",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };

  return new Intl.DateTimeFormat("en-US", options).format(date);
}

const AdComponent = ({ data , setAdModal , setDeleteModal}) => {
  const [mediaOptions, setMediaOptions] = useState({ type: null, url: null });
  const [isOpen, setIsOpen] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [reportModal, setReportModal] = useState({
    from: "",
    to: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setReportModal((prev) => ({ ...prev, [name]: value }));
  };

  const handleDownload = () => {
    if (!reportModal.from || !reportModal.to) {
      alert("Please select both dates.");
      return;
    }

    const url = `${path}/extraction/adPerformanceReport/${data._id}`;

    const query = new URLSearchParams({
      rangeFrom: reportModal.from,
      rangeUpto: reportModal.to,
    }).toString();

    window.open(`${url}?${query}`, "_blank");
    setShowReportModal(false);
  };



  const handleMedia = () => {
    setMediaOptions({ type: data.media.type, url: data.media.url });
    setIsOpen(true);
  };

 

  return (
    <div className=" w-full max-w-sm bg-white rounded-lg  overflow-hidden">
      {isOpen && (
        <MediaModal
          media={mediaOptions.url}
          type={mediaOptions.type}
          setIsOpen={setIsOpen}
        />
      )}
      
      {showReportModal && (
        <div className="fixed w-full h-screen bg-black/40 flex items-center justify-center inset-0 z-20">
          <div className="bg-white p-6 rounded-lg flex flex-col gap-4 w-80 relative">

            {/* Close Button */}
            <button
              onClick={() => setShowReportModal(false)}
              className="absolute top-2 right-2 text-gray-500 hover:text-black text-lg"
            >
              &times;
            </button>

            <h2 className="text-lg font-semibold">Download Ad Performance Report</h2>

            <div className="flex flex-col gap-1">
              <label htmlFor="from" className="text-sm">From Date</label>
              <input
                type="date"
                id="from"
                name="from"
                value={reportModal.from}
                onChange={handleChange}
                className="border p-2 rounded"
              />
            </div>

            <div className="flex flex-col gap-1">
              <label htmlFor="to" className="text-sm">To Date</label>
              <input
                type="date"
                id="to"
                name="to"
                value={reportModal.to}
                onChange={handleChange}
                className="border p-2 rounded"
              />
            </div>

            <button
              onClick={handleDownload}
              className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700"
            >
              Download CSV
            </button>
          </div>
        </div>
      )}

      <div className=" cursor-pointer" onClick={() => handleMedia()}>
        {data.media.type === "image" ? (
          <img
            alt="ad image"
            src={data?.media?.url}
            className=" w-full h-[200px] object-cover"
          />
        ) : (
          <video
            alt="ad video"
            className=" w-full h-[200px] object-cover"
            src={data.media.url}></video>
        )}
      </div>
      <div className=" flex flex-col gap-4 my-2 p-4">
        <div className=" flex items-start gap-2 ">
          <p className="font-gilroy-semibold text-gray-500">Title :</p>
          <p className="font-gilroy-semibold">{data?.title}</p>
        </div>
        <div className=" flex items-start gap-2 ">
          <p className="font-gilroy-semibold text-gray-500">Description:</p>
          <p className="font-gilroy-semibold">{data?.description}</p>
        </div>
        <div className=" flex items-start gap-2 ">
          <p className="font-gilroy-semibold text-gray-500">expiresAt:</p>
          <p className="font-gilroy-semibold">{data?.expiresAt? formatDate(data?.expiresAt): "null"}</p>
        </div>
        <div className="flex items-center justify-between rounded-xl bg-gray-100 m-1 p-4">
          <p className=" text-gray-500 text-sm">{data?.action?.message?.body}</p>
          <a
            href={data?.action?.link}
            className=" px-6 py-2 bg-blue-500 text-white rounded-lg">
            {data?.action?.buttonText}
          </a>
        </div>

        <div className=" flex items-center justify-center w-full gap-4">
          <button className=" px-8 py-2 text-white bg-green-500 rounded-lg" onClick={()=>setAdModal({type:"editAd",ad:data})}>
            Edit
          </button>
          <button className=" px-8 py-2 text-white bg-red-500 rounded-lg" onClick={()=>setDeleteModal({type:"advertisment",id:data._id})}>
            Delete
          </button>
          <button className=" px-8 py-2 text-white bg-blue-500 rounded-lg" onClick={()=>{setShowReportModal(true)}}>
            Get Report
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdComponent;
